define(['jquery'], $ => {
    const daDataPublicKey = window.daDataApiKey,
        DADATA_URL = window.daDataApiUrl,
        params = {
            type: 'GET',
            contentType: 'application/json',
            headers: {
                Authorization: `Token ${daDataPublicKey}`,
            },
        };

    return {
        getGeoLocationRequest(query) {
            params.type = 'POST';

            return $.ajax({
                url: `${DADATA_URL}/geolocate/address`,
                ...params,
                data: JSON.stringify(query),
            });
        },

        getIpLocationRequest() {
            return $.ajax(`${DADATA_URL}/iplocate/address`, params);
        },
    };
});
